<template>
    <van-row class="header_bar">
        <van-col span="2" class="backIcon" style="display: flex; justify-content: center; align-items: center;">
            <img src="@/assets/themetwo/back.png" alt="" @click="handleBackClick">
        </van-col>
        <van-col span="18">
            <van-notice-bar class="notice_container" scrollable speed="50"
                 :text="noticeText">
                <template #left-icon>
                    <img src="@/assets/themetwo/carousel_icon.png" alt="">
                </template>
            </van-notice-bar>
        </van-col>
        <van-col span="2" style="display: flex; justify-content: center; align-items: center;">
            <div class="startIcon" @click="addFavorite"
                :style="{ background: isFavorite ? 'linear-gradient(135deg, #ff940b, #ffee00)' : 'linear-gradient(135deg, #66319c, #f1a3ff)' }">
                <van-icon name="star" size="2vh" color="#312734" />
            </div>
        </van-col>
        <van-col span="2" class="walletIcon" style="display: flex; justify-content: center; align-items: center;">
            <img src="@/assets/games/wallet.png" @click="navDeposit" alt="">
        </van-col>
    </van-row>
</template>
<script setup lang="ts">
import { ref, defineProps} from 'vue'
const props = defineProps<{
    noticeText ?: string,
    isFavorite ?: boolean
}>()
const emits = defineEmits(['backClick', 'showDepositPopup', 'addFavorite'])
const handleBackClick = () => {
    emits('backClick')
}

const addFavorite = () => {
     emits('addFavorite')
}

const navDeposit = () => {
    emits('showDepositPopup')
}

</script>
<style scoped>
.header_bar {
    background: #312734 !important;
    color: #ffffffd9;
    z-index: 1000;
    padding: 1.25vh;
}

.backIcon img {
    width: 100%;
}

.van-notice-bar {
    background: linear-gradient(90deg, #ff570300, #ffffff42, #dfdede00);
    font-size: 12px;
    color: #fff;
    padding: 0;
}

.notice_container img {
    height: 100%;
    padding-right: 5px;
}

.startIcon {
    width: 3vh;
    height: 3vh;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 30px;
    background: linear-gradient(135deg, #9c6e31, #ffee00);

}

.walletIcon img {
    height: 3.5vh;
}
</style>